import type { TagSuggestionKind } from '../types';

export const SUGGESTION_DEBOUNCE_MS = 200;

/** How much a reviewer must type before the domain is searched, per vocabulary.
 *
 *  Equipment tags are few enough that the empty query is a useful "what does this
 *  domain have" list. The instrument vocabulary is not: it carries AI placeholder
 *  tags that outrank real tags on drawing count, so a short query returns noise.
 *  Two characters is enough to sift them out. */
export const MINIMUM_QUERY_LENGTH: Record<TagSuggestionKind, number> = {
  equipment: 0,
  instrument: 2,
};
